import { SECOND } from 'core/common/constants';
import { delay } from 'core/common/utils/delay';
import { ObservabilitySystem } from '../interfaces';
import { getFlushableTracerProvider } from './getFlushableTracerProvider';

export const flushSpans = async (observabilitySystem: ObservabilitySystem) => {
  const provider = getFlushableTracerProvider(observabilitySystem);

  if (!provider) {
    return;
  }

  await Promise.race([provider.forceFlush().catch(() => {}), delay(SECOND)]);
};
